import { useEffect } from "react";

import {
    ConfluenceTemplatesUnifiedRelayPageTemplate,
    ConfluenceTemplatesUnifiedRelayPageTemplateProps
} from "@/templates/software/confluence/templates/confluence-templates-page/src/relay/confluence-templates-unified-relay-page.template";
import { experiments, useExperimentExposure } from "@/utils/experiment";

export type ConfluenceTemplateSearchRelayPageProps =
    ConfluenceTemplatesUnifiedRelayPageTemplateProps;

export const ConfluenceTemplateSearchRelayPage = ({
    queryRef
}: ConfluenceTemplateSearchRelayPageProps) => {
    const [relayExposureFired, fireRelayExposure] = useExperimentExposure(
        experiments.gwpAddRelayToConfluenceTemplatesLanding
    );

    useEffect(() => {
        if (!relayExposureFired) {
            fireRelayExposure();
        }
    }, [relayExposureFired, fireRelayExposure]);

    return <ConfluenceTemplatesUnifiedRelayPageTemplate queryRef={queryRef} />;
};
